/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_All_B_To_A_TitleInputs */



/**
* | output |
* | --- |
* | "Apply all compared changes from Group B to Group A" |
*
* @param {Compare_Event_Groups_Apply_All_B_To_A_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_all_b_to_a_title = /** @type {((inputs?: Compare_Event_Groups_Apply_All_B_To_A_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_All_B_To_A_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer toutes les variations comparées du groupe B au groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übertragen Sie alle verglichenen Änderungen von Gruppe B auf Gruppe A")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicare tutte le modifiche confrontate dal Gruppo B al Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примените все сравнительные изменения из группы B к группе A.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar todos los cambios comparados del Grupo B al Grupo A.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将B组的所有比较变化应用于A组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBからグループAへ比較対象の全ての変更を適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह B से समूह A पर तुलना किए गए सभी परिवर्तनों को लागू करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar todas as alterações comparadas do Grupo B ao Grupo A.")
	return /** @type {LocalizedString} */ ("Apply all compared changes from Group B to Group A")
});